import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {MxSharedModule} from 'mx-core';

@Component({
  selector: 'prl-panel',
  standalone: true,
  imports: [
    MatExpansionPanel,
    MatExpansionPanelHeader,
    MatExpansionPanelTitle,
    MxSharedModule
  ],
  templateUrl: './prl-panel.component.html',
  styleUrl: './prl-panel.component.scss',
})
export class PrlPanelComponent {
  @Input() heading: string;
  @ViewChild(MatExpansionPanel) panel!: MatExpansionPanel;

  @Output()
  expandedChange = new EventEmitter<boolean>();

  onExpandedChange(state: boolean) {
    this.expandedChange.emit(state);
  }
}